module.exports = __webpack_public_path__ + "img/norway-ovarian-cancer-female.b389d52d.png";